// See CampaignFolderContextMenu.js for note
import connectMenu from "../../helpers/connectMenu";
import FolderContextMenu from "../tree-general/FolderContextMenu";

const LayoutFolderContextMenu = connectMenu("layout-tree-folder")(FolderContextMenu);
export default LayoutFolderContextMenu;
